// Live PaperTrail versions for the recent activity sidebar (user 1).
import getCableConsumer from "./consumer";

export function createRecentActivitiesSubscription(onCreated) {
  return getCableConsumer().subscriptions.create("RecentActivitiesChannel", {
    received(data) {
      if (data?.action === "created" && data.activity) {
        onCreated(data.activity);
      }
    },
  });
}
